import { Flex, Text, Switch, Tooltip } from '@chakra-ui/react';

const MonthlyAnnualToggle = ({
  value,
  onChange,
  size = 'md',
  monthlyDisabled = false,
  monthlyDisabledTooltip = "You're on an annual plan, please contact sales to downgrade.",
}) => {
  const isAnnually = monthlyDisabled || value === 'annually';

  const baseLabelProps = {
    textStyle: 'bodyFamilyRegular',
    fontSize: '16px',
    userSelect: 'none',
  };

  const monthlyLabel = (
    <Text
      {...baseLabelProps}
      color={monthlyDisabled ? 'grey' : 'primaryDark'}
      cursor={monthlyDisabled ? 'not-allowed' : 'pointer'}
      onClick={monthlyDisabled ? undefined : () => onChange('monthly')}
    >
      Monthly
    </Text>
  );

  return (
    <Flex align="center" gap={3} w="fit-content">
      {monthlyDisabled ? (
        <Tooltip label={monthlyDisabledTooltip} hasArrow>
          {monthlyLabel}
        </Tooltip>
      ) : (
        monthlyLabel
      )}
      <Switch
        size={size}
        isChecked={isAnnually}
        isDisabled={monthlyDisabled}
        onChange={() => onChange(isAnnually ? 'monthly' : 'annually')}
        aria-label="Toggle between monthly and annual billing"
        sx={{
          '.chakra-switch__track': { bg: 'orangePrimary' },
          '.chakra-switch__track[data-checked]': { bg: 'orangePrimary' },
        }}
      />
      <Text
        {...baseLabelProps}
        color="primaryDark"
        cursor="pointer"
        onClick={() => onChange('annually')}
      >
        Annually
      </Text>
    </Flex>
  );
};

export default MonthlyAnnualToggle;
